const FEATURE_FLAGS = {
  MAINTENANCE_MODE: true,
}

export const isFeatureFlagEnabled = (featureFlag: keyof typeof FEATURE_FLAGS) => {
  return FEATURE_FLAGS[featureFlag]
}
